// WS transport errors can be arrays rather than ordinary GraphQL responses.
export function isAuthenticationError(error) {
  if (!error) return false;
  if (Array.isArray(error)) return error.some(isAuthenticationError);
  if (error.statusCode === 401 || error.extensions?.code === 'UNAUTHENTICATED') return true;
  if (/^(Unautorized|Unauthorized|Unauthenticated)$/i.test(error.message || '')) return true;
  return [error.graphQLErrors, error.networkError, error.errors, error.result?.errors].some(item=>item && item!==error && isAuthenticationError(item));
}
